import { render, staticRenderFns } from "./session-management.vue?vue&type=template&id=ba4c78e0"
import script from "./session-management.vue?vue&type=script&lang=js"
export * from "./session-management.vue?vue&type=script&lang=js"
import style0 from "./session-management.vue?vue&type=style&index=0&id=ba4c78e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports